import React, { useContext } from 'react';

const FirebaseContext = React.createContext<any | null>(null);

export const withFirebase = (Component: any) => (props: any) => (
  <FirebaseContext.Consumer>
    {firebase => <Component {...props} firebase={firebase} />}
  </FirebaseContext.Consumer>
);

// Hook to use Firebase context
export const useFirebase = () => {
  const firebase = useContext(FirebaseContext);
  if (!firebase) {
    throw new Error('useFirebase must be used within a Firebase provider');
  }
  return firebase;
};

export default FirebaseContext;
